import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconMinus from 'components/icons/iconMinus';
import IconPlus from 'components/icons/iconPlus';
import IconTrash from 'components/icons/IconTrash';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import { colorGrayOverlay, colorGray } from 'styles/layout/colors';
const MAX_ITEMS = 16;
const Quantity = t0 => {
  const $ = _c(28);
  const {
    issue: t1,
    maxQuantity: t2,
    minQuantity: t3,
    onAddItem,
    onAddItemMaxQuantity: t4,
    onRemoveItem,
    onRemoveItemMinQuantity: t5,
    quantity,
    unavailableFabric: t6,
    variant
  } = t0;
  const issue = t1 === undefined ? null : t1;
  const maxQuantity = t2 === undefined ? MAX_ITEMS : t2;
  const minQuantity = t3 === undefined ? 0 : t3;
  const onAddItemMaxQuantity = t4 === undefined ? _temp : t4;
  const onRemoveItemMinQuantity = t5 === undefined ? _temp2 : t5;
  const unavailableFabric = t6 === undefined ? false : t6;
  const isAtMinQuantity = quantity === minQuantity;
  const hasMaxQuantity = quantity >= maxQuantity;
  const t7 = variant === "ModularItem";
  let t8;
  if ($[0] !== t7) {
    t8 = classNames("flex", {
      "mb-[.2rem]": t7
    });
    $[0] = t7;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  let t9;
  if ($[2] !== unavailableFabric) {
    t9 = classNames("flex items-center justify-center bg-white border border-solid border-gray-light6 rounded-full h-8 w-8 hover:border-brand hover:cursor-pointer", {
      "bg-gray-light6 hover:border-gray-light6 hover:cursor-default": unavailableFabric
    });
    $[2] = unavailableFabric;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  const t10 = isAtMinQuantity ? onRemoveItemMinQuantity : onRemoveItem;
  const t11 = quantity <= 1 || isAtMinQuantity || issue ? "Remove product from cart" : "Remove one of these products from cart";
  let t12;
  if ($[4] !== isAtMinQuantity || $[5] !== issue || $[6] !== quantity) {
    t12 = quantity <= 1 || isAtMinQuantity || issue ? <IconTrash width="16" height="16" color={colorGray} /> : <IconMinus width="18" height="18" color={colorGray} />;
    $[4] = isAtMinQuantity;
    $[5] = issue;
    $[6] = quantity;
    $[7] = t12;
  } else {
    t12 = $[7];
  }
  let t13;
  if ($[8] !== t10 || $[9] !== t11 || $[10] !== t12 || $[11] !== t9 || $[12] !== unavailableFabric) {
    t13 = <button type="button" className={t9} onClick={t10} aria-label={t11} disabled={unavailableFabric} data-xc="cart-quantity-decrease">{t12}</button>;
    $[8] = t10;
    $[9] = t11;
    $[10] = t12;
    $[11] = t9;
    $[12] = unavailableFabric;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <VisuallyHidden>Quantity </VisuallyHidden>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== quantity) {
    t15 = <div className="flex items-center justify-center text-base font-bold text-gray-light1 h-8 px-2 py-0" role="alert" data-xc="cart-quantity-value">{t14}{quantity}</div>;
    $[15] = quantity;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== hasMaxQuantity || $[18] !== issue || $[19] !== onAddItem || $[20] !== onAddItemMaxQuantity || $[21] !== unavailableFabric) {
    t16 = !issue && <button type="button" className={classNames("flex items-center justify-center bg-white border border-solid border-gray-light6 rounded-full h-8 w-8 hover:border-brand hover:cursor-pointer", {
      "bg-gray-light6 hover:border-gray-light6 hover:cursor-default": hasMaxQuantity || unavailableFabric
    })} onClick={hasMaxQuantity ? onAddItemMaxQuantity : onAddItem} aria-label="Add one of these products to cart" disabled={unavailableFabric || hasMaxQuantity} data-xc="cart-quantity-increase"><IconPlus width="18" height="18" color={hasMaxQuantity ? colorGrayOverlay : colorGray} /></button>;
    $[17] = hasMaxQuantity;
    $[18] = issue;
    $[19] = onAddItem;
    $[20] = onAddItemMaxQuantity;
    $[21] = unavailableFabric;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t13 || $[24] !== t15 || $[25] !== t16 || $[26] !== t8) {
    t17 = <div className={t8}>{t13}{t15}{t16}</div>;
    $[23] = t13;
    $[24] = t15;
    $[25] = t16;
    $[26] = t8;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};
Quantity.propTypes = {
  maxQuantity: PropTypes.number,
  minQuantity: PropTypes.number,
  onAddItem: PropTypes.func.isRequired,
  onAddItemMaxQuantity: PropTypes.func,
  onRemoveItem: PropTypes.func.isRequired,
  onRemoveItemMinQuantity: PropTypes.func,
  quantity: PropTypes.number.isRequired,
  issue: PropTypes.string,
  unavailableFabric: PropTypes.bool,
  variant: PropTypes.oneOf(['ModularItem'])
};
export default Quantity;
function _temp() {}
function _temp2() {}